<template>
    <MainContentSearchable title="Listado de invitaciones" id="entradas" v-model="filters" :meta="loading ? {} : entradas.meta" @updated="debouncedGetEntradas">
        <template v-slot:header>
            <h3 class="card-title">Todas las invitaciones</h3>
        </template>

        <template v-slot:extra-options>
            <div class="d-flex align-items-center flex-grow-1 justify-content-between mx-2">
                <select v-model="filters.evento_busqueda" @change="getEntradas" class="custom-select w-auto">
                    <template v-for="evento in eventos">
                        <option :value="evento.id" :key="evento.id">{{ evento.nombre }}</option>
                    </template>
                </select>

                <Button :disabled="disableGenerarInvitaciones" @click="generarInvitaciones">Generar invitaciones</Button>
                
            </div>
            <ErrorCopiarInvitaciones :errors="errors" v-on:close="closeModal('error-copiar-invitaciones')"/>
            <InvitacionesCopiadas v-on:close="closeModal('invitaciones-copiadas')" :orders="generatedOrders" :evento-id="evento_id" :sesion-id="sesion_id"/>

        </template>

        <template v-slot:content v-if="entradas">
            <div class="table-responsie has-options">
                <table class="table table-hover text-nowrap">
                    <thead>
                        <tr>
                            <th>Marcado</th>
                            <th>Nª de orden</th>
                            <th>Taquilla</th>
                            <th>Usuario</th>
                            <th>Nº</th>
                            <th>Fecha</th>
                            <th>Método de pago</th>
                            <th>Modalidad</th>
                            <th>Concepto</th>
                            <th>Precio + G.G</th>
                            <th class="text-center">Opciones</th>
                        </tr>
                    </thead>
                    <tbody v-if="!loading">
                        <template v-for="(entrada, index) in entradas.data">
                            <tr :key="index" :class="expand2.indexOf(index) >= 0 ? 'bg-light' : ''">
                                <td>
                                    <div class="custom-control custom-checkbox">
                                        <input type="checkbox" :id="'checkbox-'+entrada.id" @input="toggleCheck(entrada.id)" class="custom-control-input"/>
                                        <label :for="'checkbox-'+entrada.id" class="custom-control-label"></label>
                                    </div>
                                </td>
                                <td>{{ entrada.id }}</td>
                                <td>{{ entrada.email_taquillero }}</td>
                                <td>
                                    <span v-if="entrada.entradas[0] && entrada.entradas[0].abonado">
                                        ({{ entrada.entradas[0].abonado.n_abonado }})
                                    </span>
                                    {{ entrada.email_comprador || "NO ENVIADAS" }}
                                </td>
                                <td>{{ entrada.qr_codes.length}}</td>
                                <td>{{ entrada.fecha }}</td>
                                <td>{{ entrada.metodo_pago | formatear_metodo_pago_entrada }}</td>
                                <td>{{ entrada.modalidad | formatear_modalidad }}</td>
                                <td>{{ entrada.entradas.length > 0 ? entrada.entradas[0].concept : '' }}</td>
                                <td>
                                    <template v-if="!entrada.anulado">
                                        {{ entrada.precio | formatear_precio }}
                                    </template>
                                    <template v-else>
                                        ANULADO
                                    </template>
                                    
                                </td>
                                <td class="text-center">
                                    <Button class="mr-3" @click="expandir2(index)">Entradas</Button>
                                </td>
                            </tr>
                            <tr :key="'2-' + index" v-show="expand2.indexOf(index) >= 0" :class="expand.indexOf(index) >= 0 ? 'bg-light' : ''">
                                <td colspan="9">
                                    <div class="row">
                                        <div class="col-12">
                                            <table class="table table-hover text-nowrap">
                                                <thead>
                                                    <th>Descripción</th>
                                                    <th>Datos</th>
                                                    <th>Precio + G.G</th>
                                                    <th>Código QR</th>
                                                    <th>Zona</th>
                                                    <th>Fila / Asiento</th>
                                                    <th>Opciones</th>
                                                </thead>
                                                <tbody>
                                                    <template v-for="(ticket, index) in entrada.entradas">
                                                        <tr :key="index">
                                                            <td>{{ ticket.concepto }}</td>
                                                            <td>{{ ticket.nombre }}</td>
                                                            <td>{{ calcularPrecio(ticket) | formatear_precio }}</td>
                                                            <td>{{ ticket.qr_code }}</td>
                                                            <td>{{ zonaTicket(ticket) }}</td>
                                                            <td>{{ asientoTicket(ticket) }}</td>
                                                            <td>
                                                                <template v-if="ticket.deleted_at != null">
                                                                    ANULADA
                                                                </template>                                                                   
                                                            </td>
                                                        </tr> 
                                                    </template>                                                            
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                    <tbody v-else>
                        <tr>
                            <td colspan="7">
                                <LoaderComponent/>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </template>
    </MainContentSearchable>
</template>

<script>
    import LoaderComponent from '@/components/preloader/LoaderComponent';
    import MainContentSearchable from "@/components/backend/components/MainContentSearchable";    
    import ErrorCopiarInvitaciones from './modals/ErrorCopiarInvitaciones';
    import InvitacionesCopiadas from './modals/InvitacionesCopiadas';
    import { formatAsientoTicket, formatZonaTicket } from '@/utils/entradas/formatUbicacionEntrada';

    export default {
        props: ['evento_id', 'sesion_id'],            
        data() {
            return {
                entradas: null,
                loading: true,
                filters: {
                    per_page: 10,
                    page: 1,
                    search: '',
                    evento_busqueda: 0,
                },
                expand: [],
                sesiones: null,
                expand2: [],
                ordersChecked: {},
                errors: [],
                disableGenerarInvitaciones: true,
                eventos: [],
                generatedOrders: [],
            }
        },
        created() {
            this.imprimir_url = this.config.IMPRIMIR_URL;
            this.getEventos();
            this.debouncedGetEntradas = _.debounce(this.getEntradas, 500);
        },
        watch: {
            "filters.search"() {
                this.debouncedGetEntradas();
            }
        },
        methods: {
            calcularPrecio(entrada) {
                var precio = parseFloat(entrada.precio);

                if(!entrada.price_management_interno) {
                    precio = precio + parseFloat(entrada.price_management);
                }

                return precio;
            },
            zonaTicket(ticket) {
                return formatZonaTicket(ticket);
            },
            asientoTicket(ticket) {
                return formatAsientoTicket(ticket);
            },
            toggleCheck(id) {
                this.ordersChecked[id] = !this.ordersChecked[id];
                if(this.ordersChecked[id] == false) {
                    delete this.ordersChecked[id];
                }

                this.disableGenerarInvitaciones = Object.keys(this.ordersChecked).length == 0;
            },
            getEventos() {
                this.loading = true;
                const data = {
                    filters: this.filters,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.invitaciones.eventos'), data).then(res => {
                    this.eventos = res.data.data;
                    this.filters.evento_busqueda = this.eventos[0].id;
                    this.getEntradas();
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });
            },
            getEntradas : function() {
                this.loading = true;
                
                // Prevenir que hayan seleccionado una orden y luego cambiado de evento.
                this.ordersChecked = {};

                const data = {
                    filters: this.filters,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                };
                this.$store.dispatch(this.config.getVuexAlias('back.events.invitaciones'), data).then(res => {
                    this.entradas = res.data;
                    this.loading = false;
                }).catch(error => {
                    this.loading = false;
                });
            },
            setPage(page) {
                this.filters.page = page;
                this.getEntradas();
            },
            showModal(modal) {
                this.$modal.show(modal);
            },
            expandir(index) {
                if(this.expand.indexOf(index) >= 0) {
                    this.expand.splice(this.expand.indexOf(index), 1);
                } else {
                    this.expand.push(index);
                }
            },
            expandir2(index) {
                if(this.expand2.indexOf(index) >= 0) {
                    this.expand2.splice(this.expand2.indexOf(index), 1);
                } else {
                    this.expand2.push(index);
                }
            },
            closeModal(modal) {
                this.$modal.hide(modal);
            },
            generarInvitaciones() {
                this.disableGenerarInvitaciones = true;
                
                const params = {
                    filters : {},
                    pedidos: this.ordersChecked,
                    evento_id: this.evento_id,
                    sesion_id: this.sesion_id
                };

                this.$store.dispatch(this.config.getVuexAlias('back.events.invitaciones.copiar'), params).then(res => {
                    this.showModal("invitaciones-copiadas")
                    this.disableGenerarInvitaciones = false;
                    this.generatedOrders = res.data.data;
                }).catch(error => {
                    this.showModal("error-copiar-invitaciones")
                    this.errors = error.response.data.data;
                    this.disableGenerarInvitaciones = false;
                });
                
            }
        },
        components: {
            LoaderComponent, MainContentSearchable, ErrorCopiarInvitaciones, InvitacionesCopiadas
        }
    }
</script>
